import { EventEmitter } from '@angular/core';
var AppService = /** @class */ /*@__PURE__*/ (function () {
    function AppService() {
    }
    AppService.onLogout = new EventEmitter();
    return AppService;
}());
export { AppService };
